import { render } from "./XiaofeiChanpin.vue?vue&type=template&id=54159d72&scoped=true"
import script from "./XiaofeiChanpin.vue?vue&type=script&lang=js"
export * from "./XiaofeiChanpin.vue?vue&type=script&lang=js"

import "./XiaofeiChanpin.vue?vue&type=style&index=0&id=54159d72&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54159d72"]])

export default __exports__